import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function useTopCouponStoreRoute(coupons) {
    const { dynamicPath, couponId } = useParams();
    const navigate = useNavigate();
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        if (!couponId || !coupons?.data) return;
        const coupon = coupons.data.find(c => String(c.id) === couponId);
        if (coupon) {
        setSelectedCoupon(coupon);
        setIsModalOpen(true);
        }
    }, [couponId, coupons]);

    const openCoupon = (coupon) => {
        if (!coupon) return;

        const storeSlug = coupon?.store?.slug;
        navigate(`/cupom-desconto-${storeSlug}/${coupon.id}`, { replace: true });

        setSelectedCoupon(coupon);
        setIsModalOpen(true);
    };

    const closeCoupon = () => {
        const storeSlug = selectedCoupon?.store?.slug || dynamicPath;
        navigate(`/cupom-desconto-${storeSlug}`, { replace: true });
        setSelectedCoupon(null);
        setIsModalOpen(false);
    };

    return { selectedCoupon, isModalOpen, openCoupon, closeCoupon };
}
